/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_NoteInputs */

const en_mk_price_note = /** @type {(inputs: Mk_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch pricing — will be recalibrated once we measure real AI cost.`)
};

const id_mk_price_note = /** @type {(inputs: Mk_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga peluncuran — akan dikalibrasi ulang setelah kami mengukur biaya AI riil.`)
};

/**
* | output |
* | --- |
* | "Launch pricing — will be recalibrated once we measure real AI cost." |
*
* @param {Mk_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_note = /** @type {((inputs?: Mk_Price_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_note(inputs)
	return en_mk_price_note(inputs)
});